import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiFetch } from "../utils/api";

function VerifyEmail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const [message, setMessage] = useState("Verifying your email…");
  const [status, setStatus] = useState("pending"); // pending | success | error | info
  const [resending, setResending] = useState(false);

  useEffect(() => {
    if (!token || !email) {
      setStatus("info");
      setMessage("Check your email for the verification link we just sent.");
      return;
    }

    const verify = async () => {
      try {
        const res = await apiFetch("verifyEmail", {
          method: "POST",
          body: JSON.stringify({ token, email }),
        });
        if (res.success) {
          setStatus("success");
          setMessage(res.message || "Email verified. Redirecting to sign in…");
          setTimeout(() => navigate("/login"), 1800);
        } else {
          setStatus("error");
          setMessage(res.message || "Verification failed.");
        }
      } catch (err) {
        setStatus("error");
        setMessage(err.message || "Verification failed.");
      }
    };

    verify();
  }, [token, email, navigate]);

  const resend = async () => {
    if (!email) return;
    setResending(true);
    setStatus("pending");
    setMessage("Sending a new verification email…");
    try {
      const res = await apiFetch("resendVerification", {
        method: "POST",
        body: JSON.stringify({ email }),
      });
      setStatus(res.success ? "info" : "error");
      setMessage(res.message || (res.success ? "Verification email sent." : "Unable to resend verification email."));
    } catch (err) {
      setStatus("error");
      setMessage(err.message || "Unable to resend verification email.");
    } finally {
      setResending(false);
    }
  };

  const alertClass = {
    pending: "alert-warning",
    success: "alert-success",
    error: "alert-danger",
    info: "alert-info",
  }[status] || "alert-secondary";

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
      <div className="card shadow-sm" style={{ maxWidth: "480px", width: "100%" }}>
        <div className="card-body">
          <h3 className="card-title text-center mb-3">Verify your email</h3>
          <div className={`alert ${alertClass}`} role="alert">
            {message}
          </div>
          <p className="text-muted small text-center mb-3">
            We sent a verification link to <strong>{email || "your email"}</strong>. Check your inbox (and spam folder) to finish activating your account.
          </p>
          <div className="d-flex gap-2 justify-content-center">
            <button className="btn btn-outline-primary" onClick={() => navigate("/login")} disabled={status === "pending"}>
              Back to Sign In
            </button>
            <button className="btn btn-primary" onClick={resend} disabled={resending}>
              {resending ? "Sending…" : "Resend Email"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
